export function normalizeLines(text: string): string[] {
  return text
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);
}

export function findDuplicateLines(items: string[]): string[] {
  const seen = new Set<string>();
  const duplicates = new Set<string>();
  for (const item of items) {
    const key = item.toLowerCase();
    if (seen.has(key)) duplicates.add(item);
    seen.add(key);
  }
  return [...duplicates];
}

/** Path before ?/# must end with .xml (case-insensitive). */
export function findNonXmlSitemapUrls(items: string[]): string[] {
  return items.filter((item) => {
    try {
      const pathname = new URL(item).pathname;
      return !pathname.toLowerCase().endsWith('.xml');
    } catch {
      const path = item.split(/[?#]/, 1)[0] ?? item;
      return !path.toLowerCase().endsWith('.xml');
    }
  });
}

export function crossScheduleWarnings(
  items: string[],
  others: Array<{ name: string; items: string[] }>,
  itemLabel: string,
): string[] {
  const warnings: string[] = [];
  const own = new Set(items.map((item) => item.toLowerCase()));
  for (const other of others) {
    for (const item of other.items) {
      if (own.has(item.toLowerCase())) {
        warnings.push(
          `${itemLabel} «${item}» قبلاً در زمان‌بندی «${other.name}» اضافه شده است.`,
        );
      }
    }
  }
  return warnings;
}
